import React, { Fragment, useContext, useRef, useCallback } from 'react';
import Perfectcorp from './Perfectcorp';
import Sticker from '../Sticker';
import { IdleTimer } from '../../commonComponents';
import AppContext from '../../context';
import VMContext from '../context';
import {
  language,
  LANG_JP,
  LOOKS_TAB,
  MAKEUP_TAB,
  CLASSIC_LENS_TAB,
} from 'Root/constants';
import content from 'Content/content.json';
import { definePartner, defineFilter } from 'Root/utils';
import { showCustomFloatButton } from 'Root/constants';
import { isPartnerURL } from 'Root/utils';
import './Perfectcorp.scss';

const {
  data: {
    productInfo: {
      [language]: { classicLens, freshLens },
    },
    looks,
  },
} = content;

//@todo please use useRef as per https://github.com/facebook/react/issues/14010
// The perfectcorp event listener not getting the current context value
// so creating seprate variables outside the component and using it in callback.
let activeTab, activeLensIndex, activeSelectedLensType, activeCurrentLookIndex;

const VmPerfectCorp = ({ recommendation }) => {
  const {
    lensIndex,
    selectedLensType,
    selectedTab,
    handleLensChange,
    currentLookIndex,
    handleLooksChange,
    applyMakeUpOnLoad,
    setVmState,
    isLensTab,
    timeout,
    resetVM,
    VMImageLoaded,
  } = useContext(VMContext);
  const {
    forceLookReset,
    updateMakeupCleared,
    updateClearLens,
    forceMakeupReset,
    updateClearLooks,
    updateForceLookReset,
    updateForceMakeupReset,
    recommendation: { active },
    updateProduct,
    updateFloatButtonURL,
    updateInstagramBackgroundURL,
    onVMInit,
    updateLensGuid,
  } = useContext(AppContext);
  const vmRef = useRef();
  activeTab = selectedTab;
  activeLensIndex = lensIndex;
  activeSelectedLensType = selectedLensType;
  activeCurrentLookIndex = currentLookIndex;

  const onLoaded = useCallback(() => {
    let recommendedLensIndex = -1;
    if (activeLensIndex > -1) {
      recommendedLensIndex = activeLensIndex;
    }
    const productInfo = JSON.parse(window.sessionStorage.getItem('productInfo'));
    if (productInfo) {
      handleLensChange(productInfo.index, 0, activeSelectedLensType);
    }
    else {
      if (recommendedLensIndex > -1 && recommendedLensIndex < 7) {
        handleLensChange(recommendedLensIndex, 0, activeSelectedLensType);
      }
    }
    
    if (activeTab !== MAKEUP_TAB) {
      if (activeCurrentLookIndex > -1) {
        const foundLook = looks.find(
          (look, index) => index === activeCurrentLookIndex
        );
        handleLooksChange(foundLook, activeCurrentLookIndex);
      } else if (activeCurrentLookIndex === -1 && activeTab === LOOKS_TAB) {
        handleLooksChange(looks[0], 0);
      }
    } else {
      applyMakeUpOnLoad();
    }
  }, []);
  const onEngineClosed = useCallback(() => {
    setVmState({
      lookCurrentlyApplied: -1,
      VMImageLoaded: false,
      isMakeUpApplied: false,
      isLookApplied: false,
    });
  }, []);

  const onReset = useCallback(() => {

    window.sessionStorage.clear();
    if (activeTab === MAKEUP_TAB && !forceLookReset) {
      updateMakeupCleared(true);
      setVmState({
        selectedMakeup: {
          blush: null,
          eyeliner: null,
          lipcolors: null,
          eyelashes: null,
          eyeshadow: null,
        },
      });
    } else if (isLensTab(activeTab)) {
      updateClearLens(true);
      updateLensGuid('');
    } else if (activeTab === LOOKS_TAB && !forceMakeupReset) {
      updateClearLooks(true);
      setVmState({ isLookApplied: false });
    }
    updateClearLooks(true);
    setVmState({
      lookCurrentlyApplied: -1,
      isMakeUpApplied: false,
      isLookApplied: false,
    });
    updateForceLookReset(false);
    updateForceMakeupReset(false);
  }, []);

  const onCompare = useCallback(() => {
    // Not Sure why are we calling this here and we are getting 0 as value of lensIndex from context
    // handleLensChange(lensIndex, 0, selectedLensType);
  }, []);

  const onLibLoaded = useCallback(() => {
    let recommendedLensIndex = recommendation;
    let tempRecommendedLook = recommendation;
    let tempRecommendedLens = recommendation;
    if (!recommendedLensIndex) {
      recommendedLensIndex = 0;
      tempRecommendedLook = -1;
      tempRecommendedLens = -1;
    }
    if (active > -1) {
      recommendedLensIndex = active;
    }
    setVmState({
      tempRecommendedLook,
      tempRecommendedLens,
      isMakeUpApplied: false,
    });
    // Update product in context state
    const lenses =
      activeSelectedLensType === CLASSIC_LENS_TAB ? classicLens : freshLens;
    const lens = lenses[recommendedLensIndex] || null;
    if (lens) {
      updateProduct(recommendedLensIndex, lens.id);
      updateLensGuid(lens.guid, lens.key);
      if(showCustomFloatButton && isPartnerURL() && lens.partner !== undefined && lens.partner[definePartner()] !== undefined) {
        updateFloatButtonURL(lens.partner[definePartner()]);
      }
      if(lens.instagram !== undefined) {
        updateInstagramBackgroundURL(lens.instagram[defineFilter()]);
      }
      handleLensChange(recommendedLensIndex, 0, activeSelectedLensType);
    }
    // Initialise context states
    onVMInit();
  }, []);
  return (
    <Fragment>
      <IdleTimer onIdle={resetVM} timeout={timeout} />
      <Perfectcorp
        vmRef={vmRef}
        onLoaded={onLoaded}
        onEngineClosed={onEngineClosed}
        onReset={onReset}
        onCompare={onCompare}
        onLibLoaded={onLibLoaded}
      />
      {VMImageLoaded && language === LANG_JP && <Sticker vmRef={vmRef} />}
    </Fragment>
  );
};

export default VmPerfectCorp;
